import React, { Component } from 'react';
import { translate } from 'react-i18next';

class GraciasSurvey extends Component {

  render() {
    let encuesta = this.props.encuesta;  
    const { t } = this.props;
    
    if(encuesta){
        return(
          <div id="graciasSurvey" className="survey-page-body hidden" style={{color: "#"+encuesta.color_letra}}>
            <div className="alert alert-info" >
             {encuesta.texto_final}
            </div>
          </div>
        );
    }else{
        return(<div></div>);
    }
  }
}

export default translate('common')(GraciasSurvey);



// WEBPACK FOOTER //
// ./src/guest/GetSurveyData/GraciasSurvey.js